import {useEffect} from 'react'
import { closePopup, dialogTypeSelector, isOpenSelector, popupContentSelector } from '../../app/popup-slice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import styles from './popup.module.css'
import { InfoQualityDialog } from '../info-quality-dialog/info-quality-dialog';
import { InfoLegendDialog } from '../info-legend-dialog/info-legend-dialog';
import { InfoModelDialog } from '../info-model-dialog/info-model-dialog';
import { SaveConfigDialog } from '../save-configuration-dialog/save-configuration-dialog';
import { DeleteConfirmDialog } from '../delete-cofirm-dialog/delete-cofirm-dialog';
import { InfoWarningDialog } from '../info-warning-dialog/info-warning-dialog';
import { BasketsModal } from '../baskets-modal/baskets-modal';
import { LoadPreviousConfigDialog } from '../../view/load-previous-config-dialog/load-previous-config-dialog';
import { MessageDialog } from '../../view/message-dialog/message-dialog';

export const Popup = () => {
  const popupContent = useAppSelector(popupContentSelector);
  const popupType = useAppSelector(dialogTypeSelector);
  const dispatch = useAppDispatch();
  const isOpenPopup = useAppSelector(isOpenSelector)

  const onClosePopup = () => {
    dispatch(closePopup());
  }
  const onClickContent = (event: React.MouseEvent) => {
    event.stopPropagation()
  }

  useEffect(()=>{
    return(()=> {
      dispatch(closePopup());
    })
  },[])

  const getDialog = () => {
    switch (popupType) {
      case 'infoQuality':
        return <InfoQualityDialog materialInfo={popupContent}/>
      case 'infoLegend':
        return <InfoLegendDialog/>
      case 'infoModel':
        return <InfoModelDialog modelName={popupContent ? popupContent.modelName : ""}/>
      case 'saveConfig':
        return <SaveConfigDialog/>
      case 'loadConfig':
        return <LoadPreviousConfigDialog/>
      case 'deleteConfirm':
        return <DeleteConfirmDialog/>
      case 'warningInfo':
        return <InfoWarningDialog/>
      case 'message':
        return <MessageDialog/>
      case 'baskets':
        return <BasketsModal/>
      default:
        break;
    }
  }

  const dialogClassName = () => {
    if(popupType === 'saveConfig') {
      return styles.popupContentBig
    } else if(popupType === 'deleteConfirm' || popupType === 'warningInfo') {
      return styles.popupContentShort
    } else if(popupType === 'loadConfig' || popupType === 'message') {
      return styles.popupContentMedium
    } else if(popupType === 'baskets') {
      return styles.popupContentBaskets
    } else {
        return styles.popupContent
    }
  }

  return (
    isOpenPopup && (
      <div className={styles.popupOverlay} onClick={onClosePopup}>
        <div className={dialogClassName()} onClick={onClickContent}>
            {getDialog()}
        </div>
      </div>)
  );
};

export default Popup;